module.exports = __webpack_public_path__ + "img/preferably.170c51ca.png";